import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';
import classnames from 'classnames';
import { get } from 'lodash';

import InstagramLink from '../../components/InstagramLink';
import YelpRating from '../../components/YelpRating';
import { shopShape } from '../../shapes';
import config from '../../../config';
import Distance from './Distance';
import analytics from '../../applicationServices/analytics/BookingAnalytics';

const Shop = ({ selected, shop, url }) => {
  const imgSource = get(shop, 'photos[0].thumbnail') || config.fallbackShopThumbnail;
  const boxClassName = classnames(
    'c-select-box',
    'c-select-box--with-overlay',
    { 'is-active': selected }
  );

  return (
    <Link
      className={boxClassName}
      style={{ backgroundImage: `url(${imgSource})` }}
      to={url}
      onClick={() => { analytics.selectShop(shop); }}
    >
      <div className="u-pin-bottom u-p">
        <div className="c-heading c-heading--large u-mb- u-co-white">{shop.name}</div>
        <div className="u-co-teal-blue">{shop.address}</div>
        <YelpRating className="u-mt-" rating={shop.yelpRating} yelpId={shop.yelpID} />
      </div>
      <Distance distance={shop.distance} />
      <div className="u-pin-bottom-right">
        <InstagramLink user={shop.instagram} />
      </div>
    </Link>
  );
};
Shop.propTypes = {
  selected: PropTypes.bool,
  shop: shopShape.isRequired,
  url: PropTypes.string.isRequired,
};
Shop.defaultProps = {
  selected: false,
  distance: 0,
};

export default Shop;



// WEBPACK FOOTER //
// ./src/app/shops/components/Shop.jsx